import { MARKETPLACE_TIER_DISPLAYS } from '@/components/admin/AdminPricing/constants';

export const tierOptions = Object.values(MARKETPLACE_TIER_DISPLAYS).map((o) => ({ value: o, label: o }));

export const MM_STATUSES = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'SCHEDULED', label: 'Scheduled' },
    { value: 'IN_TRANSIT', label: 'In-Transit' },
    { value: 'ARRIVED', label: 'Arrived' },
];

export const wh_statuses = [
    { value: 'RECEIVED', label: 'Received' },
    { value: 'NOT_DELIVERED', label: 'Not Received' },
];

export const order_types = [
    { value: 'delivery', label: 'Delivery' },
    { value: 'return', label: 'Return' },
    { value: 'exchange', label: 'Exchange' },
    { value: 'service', label: 'Service Callback' },
    { value: 'will_call', label: 'Will Call' },
    { value: 'wh_inventory', label: 'Inventory' },
];

export const order_kind_options = [
    { value: 'MM + Delivery', label: 'MM + Delivery' },
    { value: 'Receiving + Delivery', label: 'Receiving + Delivery' },
    { value: 'Pickup + Delivery', label: 'Pickup + Delivery' },
];
